import React, { useRef, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import classnames from 'classnames/bind';

import { useAnalytics } from '../../../hooks/use-analytics';

import {ANALYTICS_BUTTON_NAME, ANALYTICS_EVENT, ANALYTICS_PAGE_TYPE, APPNAME, FASTSCAN, MAP_PROD_TO_LOCA} from '../../../constants';

import logo from '../../../images/castrol-logo.svg';
import globe from '../../../images/bp-globe-pictograms-bp-silver-.svg';
import arrow from '../../../images/bp-arrow-move-right-pictograms-bp-silver-.svg';

import style from './index.module.scss';

import localesReplacement from '../../../utils/localesReplacement';

const cx = classnames.bind(style);

const ExternalLink = () => {

  const sendAnalytics = useAnalytics();
  const ref = useRef<HTMLDivElement>(null);
  const [ link, setLink ] = useState<string>('');

  const country = useSelector((state: any) => state.country);
  const replacements = useSelector((state: any) => state.replacements);

  useEffect(() => {
    const element = (ref?.current as any);
    const handler = (event: any) => {
      const target = event.target;
      const link = target.dataset.link;
      const marketing = target.dataset.marketing;
      setLink(new URL(link).origin);
    }
    if (element) {
      element.popover = 'auto';
      element.addEventListener('beforetoggle', handler);
    }
    return () => {
      element.removeEventListener('beforetoggle', handler);
    }
  }, [ref]);

  const close = () => {

    (ref?.current as any).hidePopover();
  }

  const open = () => {
    const link = (ref?.current as any).dataset.link;
    window.open(link, '_blank');

    if ((ref?.current as any).dataset.analytics && !(ref?.current as any).marketing) {
      const event =  {
        event: ANALYTICS_EVENT.BUY_ONLINE_CLICKS ,
        page: ANALYTICS_PAGE_TYPE.RECOMMENDED_OILS,
        recommendation: (ref?.current as any).dataset.recommendation,
        button: ANALYTICS_BUTTON_NAME.BUY_ONLINE_BUTTON_PREFIX  + (ref?.current as any).dataset.text,
        oilName: (ref?.current as any).dataset.name,
        oilCategory: (ref?.current as any).dataset.product,
        model: (ref?.current as any).dataset.vehicle,
        country: country.isoCode
      }
      sendAnalytics(event);
    }

    setTimeout(() => {
      (ref?.current as any).hidePopover();
    }, 100);
  }

  return (
    <div className={cx('container')} id="external-link-popover" ref={ref}>
      <div className={cx('inner')}>
        <div className={cx('header')}>
          <img src={logo} />
          <img src={arrow} />
          <img src={globe} />
        </div>
        <div className={cx('body')}>
          <h4> {localesReplacement(replacements, 'Leaving Castrol')} </h4>
          <p> {localesReplacement(replacements, 'You clicked link that redirects to external website')}:<br/> <strong> {link} </strong> </p>
          <h5> {localesReplacement(replacements, 'Are you sure to continue')} </h5>
        </div>
      </div>
      <div className={cx('actions')}>
        <button onClick={close} className="secondary-button"> {localesReplacement(replacements, 'Stay on Castrol')} </button>
        <button onClick={open} className="primary-button"> {localesReplacement(replacements, 'Continue')} </button>
      </div>
      <div className={cx('footer')}>
        <p>
          <a href="https://www.castrol.com/en/global/corporate/legal-notice.html">
            {localesReplacement(replacements, 'Learn more')}
          </a>
          {localesReplacement(replacements, 'about verifying links from trusted sources')}
        </p>
      </div>
    </div>
  );
}

export default ExternalLink;
